import { useMessageSource } from "react-message-source";
import * as Yup from "yup";
import { useAddressValidator } from "../shared/components/address-select/validator";
import useBirthDateValidator from "../shared/components/birth-date/validator";
import useEmailValidator from "../shared/components/email/validator";
import { useTextInputValidator } from "../shared/components/formik/text-input/validator";
import useGenderValidator from "../shared/components/gender/validator";
import usePhoneNumberValidator from "../shared/components/phone/validator";
import { useMandatoryStringTypeValidator } from "../shared/components/validator";
import { Attorney, AttorneyValues } from "./types";

export default function usePowerOfAttorneyValidationSchema() {
  const { getMessage } = useMessageSource();

  const validatePerson = Yup.array().of(
    Yup.object().shape({
      gender: useGenderValidator(),
      firstName: useTextInputValidator(),
      lastName: useTextInputValidator(),
      nationality: useMandatoryStringTypeValidator(),
      birthdate: useBirthDateValidator(),
      fullStreet: useTextInputValidator(),
      address: useAddressValidator(),
      mobile: usePhoneNumberValidator(),
      emailBusiness: useEmailValidator(),
    }),
  );

  const validateSecurityCode = Yup.string()
    .min(4, getMessage("Validation.message-minLengthCharacters", 4))
    .max(18, getMessage("Validation.message-maxLengthCharacters", 18))
    .matches(
      /^[\u{00C0}-\u{00ff}a-zA-Z0-9 ]+$/u,
      getMessage("Validation.message-mustNotContainSpecialChars"),
    );

  return Yup.object().shape({
    securityCode: Yup.string()
      .nullable()
      .when("attorneyType", {
        is: (attorneyType: Attorney) =>
          attorneyType === AttorneyValues.OTHER ||
          attorneyType === AttorneyValues.ADMIN,
        then: () => validateSecurityCode,
      }),
    attorneysData: Yup.array().when("attorneyType", {
      is: AttorneyValues.OTHER,
      then: () => validatePerson,
    }),
    adminAttorneysData: Yup.array().when("attorneyType", {
      is: AttorneyValues.ADMIN,
      then: () => validatePerson,
    }),
  });
}
